import { defineStore } from "pinia";
import { ErrorMessageFormatter } from "@/core/Services/GlobalFunctions";
import DashboardService from "@/modules/Parkom/Services/DashboardService";
import { useToast } from "vue-toastification";
import { DigitalParkingSigns } from "@/modules/Parkom/Services/DashboardTypes";

export const useDigitalParkingSigns = defineStore("digitalParkingSignsFilter", {
  state: () => {
    return {
      dashboardService: new DashboardService(),
      selectedDigitalParkingSignsIds: [] as number[],
      digitalParkingSignsTreeList: [] as DigitalParkingSigns[],
      toast: useToast(),
    };
  },

  actions: {
    async getDigitalParkingSignsTreeList() {
      try {
        this.digitalParkingSignsTreeList =
          await this.dashboardService.getDigitalParkingSignsTreeList();
        this.selectedDigitalParkingSignsIds = this.digitalParkingSignsTreeList
          .filter((display) => !!display.displayId)
          .map((display) => display.displayId) as number[];
      } catch (error) {
        this.toast.error(ErrorMessageFormatter(error));
      }
    },
  },
});